<template>
  <Autosuggest
    :model.sync="displayText"
    :suggestions="localOptions"
    :placeholder="placeholder"
    suggestion-name="fullName"
    :limit="limit"
    :loading="loading || isSearching"
    :show-clear="showClear"
    @change="onChange"
    @select="onSelect"
  />
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import decounce from 'debounce';
import { searchCustomers } from '@/utils/customerSearch';
import { TIME_TRIGGER } from '@/utils/constants';

export default {
  name: 'SupplierAutosuggest',
  components: { Autosuggest },
  props: {
    /** v-model: providerId (Number | null) */
    value: { type: [Number, String], default: null },
    /** Label hiển thị cho giá trị hiện tại (khi edit record cũ) */
    initialLabel: { type: String, default: '' },
    allowAll: { type: Boolean, default: false },
    activeOnly: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Tên nhà cung cấp' },
    limit: { type: Number, default: 10 },
    loading: { type: Boolean, default: false },
    queryParams: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      displayText: this.initialLabel || '',
      localOptions: [],
      isSearching: false,
    };
  },
  watch: {
    initialLabel(val) {
      if (this.value != null) this.displayText = val || '';
    },
    value(newVal) {
      if (newVal == null) this.displayText = '';
    },
    queryParams: {
      handler(val, oldVal) {
        if (val?.parentId) {
          this._loadByParentId();
        } else if (oldVal?.parentId) {
          this.localOptions = [];
          this.$emit('options-updated', this.localOptions);
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.queryParams?.parentId) {
      this._loadByParentId();
    }
  },
  computed: {
    showClear() {
      return this.allowAll && !!(this.displayText || this.value != null);
    },
  },
  created() {
    this._debounceSearch = decounce(this._fetchCustomers.bind(this), TIME_TRIGGER);
  },
  methods: {
    onChange(text) {
      this.displayText = text;
      this.$emit('search-change', text);
      if (!text || !text.trim()) {
        this.localOptions = [];
        this.$emit('options-updated', this.localOptions);
        if (this.allowAll) {
          this.$emit('input', null);
          this.$emit('selected', null);
        }
        return;
      }
      this._debounceSearch(text);
    },
    onSelect(option) {
      if (option && option.item) {
        const item = option.item;
        this.displayText = item.fullName || '';
        this.$emit('input', item.id != null ? Number(item.id) : null);
        this.$emit('selected', item);
      } else {
        this.displayText = '';
        this.$emit('input', null);
        this.$emit('selected', null);
      }
    },
    async _loadByParentId() {
      if (!this.queryParams?.parentId) return;
      this.isSearching = true;
      try {
        const size = Math.max(this.limit, 100);
        this.localOptions = await searchCustomers('', size, this.activeOnly, this.queryParams);
        this.$emit('options-updated', this.localOptions);
      } finally {
        this.isSearching = false;
      }
    },
    async _fetchCustomers(text) {
      if (!text || !text.trim()) return;
      this.isSearching = true;
      try {
        this.localOptions = await searchCustomers(text, this.limit, this.activeOnly, this.queryParams);
        this.$emit('options-updated', this.localOptions);
      } finally {
        this.isSearching = false;
      }
    },
  },
};
</script>
